export default __webpack_public_path__ + "static/media/IQ.2d2a7f22.svg";